import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.popover', {
      wrapper: {
        bg: 'white',
        filter: 'drop-shadow(0px 2px 8px rgba(0,15,78,0.1))',
        borderRadius: 'control',
        py: 8,
        zIndex: 800,
      },
      arrow: {
        position: 'absolute',
        zIndex: -1,
        size: 10,
        '[data-popper-placement^="right"] > &': {
          left: -4,
        },
        '[data-popper-placement^="left"] > &': {
          right: -4,
        },
        '[data-popper-placement^="top"] > &': {
          bottom: -4,
        },
        '[data-popper-placement^="bottom"] > &': {
          top: -4,
        },
        '&:before': {
          zIndex: -1,
          bg: 'white',
          position: 'absolute',
          content: '""',
          size: 10,
          transform: 'rotate(45deg)',
        },
      },
    }),
  ]
}
